import styled from 'styled-components';

export const ReportingResetConfirmationContainer = styled.div`
  background-color: ${(props) => props.theme.newPalette.turquoise.T100};
`;
